import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import FilterListIcon from '@mui/icons-material/FilterList'
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro'
import { Dropdown } from '@carsys/ui'
import { FilterOption } from './types.d'

interface GridFilterSelectionProps extends GridFilterInputValueProps {
  options: FilterOption[]
  clearButton?: React.ReactNode
}

export function GridHeaderFilterSingleSelect(props: GridFilterSelectionProps) {
  const { item, applyValue, clearButton, options } = props
  const optionList = options.map(option => ({
    value: option.value,
    text: option.label
  }))

  return (
    <Stack direction='row' alignItems='center' gap={0.5} flex='1 1 auto' overflow='hidden'>
      <Box display='inline-flex' margin='auto 5px 10px 0px'>
        <FilterListIcon
          sx={{
            color: theme => theme.palette.action.disabled
          }}
        />
      </Box>
      <Box flex={1} overflow='hidden'>
        <Dropdown
          options={optionList}
          variant='standard'
          value={item.value ?? ''}
          fullWidth
          onChange={props => {
            applyValue({ ...item, value: props.target.value })
          }}
        />
      </Box>
      {clearButton ? (
        // inline-flex is required so it lines out towards the bottom
        // auto 0 10px 5px is the default margins of the buttons
        // in the header filter e.g. clear and filter menu
        <Box display='inline-flex' margin='auto 0 10px 5px'>
          {clearButton}
        </Box>
      ) : null}
    </Stack>
  )
}
